export default {
  id: 'optimizer_trace',
  routerPrefix: '/optimizer_trace',
  reactRoot: () => import('.')
}
